import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-document",
  "use": "svg-icon-document-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 13\" id=\"svg-icon-document\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#97A1A5\" stroke-width=\"1.623\" d=\"M6.439.865v4.187h4.084\" /><path stroke=\"#97A1A5\" stroke-width=\"1.623\" d=\"M5.941 11.713H1.434V.865h5.8l3.289 3.289v1.851\" /><path d=\"M5.5 11.75h5M10.5 11.5v-7\" stroke=\"#96A1A5\" stroke-width=\"1.5\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol